import { FC } from 'react'

import { TagAgeProps } from '../TagAge'

import * as SC from './styled'

export type StepProps = {
  className?: string
  backgroundColor: string
  tagProps: TagAgeProps
  text: string
}

const Step: FC<StepProps> = (props) => {
  const { className, backgroundColor, tagProps, text } = props

  return (
    <SC.Container className={className} $backgroundColor={backgroundColor}>
      <SC.TagAge {...tagProps} />
      <SC.Text>{text}</SC.Text>
    </SC.Container>
  )
}

export default Step
